import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './core/modules/login/login/login.component';
import { AuthGuard } from './core/modules/login/auth.guard';
import { REDIRECT_DEFAULT } from './shared/defaut';
import { MainComponent } from './layouts/basic/main/main.component';
import { ResetPasswordEmailComponent } from './core/modules/reset-password/reset-password-email/reset-password-email.component';
import { ResetPasswordComponent } from './core/modules/reset-password/reset-password/reset-password.component';
import { SignUpComponent } from './core/modules/sign-up/sign-up/sign-up.component';
import { VerifyEmailComponent } from './core/modules/verify-email/verify-email/verify-email.component';
import { NonjointInviteComponent } from './core/modules/nonjoint-invite/nonjoint-invite/nonjoint-invite.component';
import { OpenApplicationComponent } from './core/modules/business-loan/open-application/open-application.component';
const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignUpComponent },
  { path: 'reset-password', component: ResetPasswordEmailComponent },
  { path: 'reset', component: ResetPasswordComponent },
  { path: 'verify-email', component: VerifyEmailComponent },
  { path: 'invite/nonjoint', component: NonjointInviteComponent },
  { path: 'invite/admin', loadChildren: () => import('./core/modules/admin-invite-accept/admin-invite-accept.module').then((m) => m.AdminInviteAcceptModule) },
  // Unguarded entrypoint for opening an application in a new tab.
  // This route performs a one-time auth handoff (nonce) then redirects to guarded steps.
  { path: 'loan/open', component: OpenApplicationComponent },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        loadChildren: () => import('./core/modules/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'role',
        loadChildren: () => import('./core/modules/role/role.module').then((m) => m.RoleModule),
      },
      {
        path: 'invite-admin',
        loadChildren: () => import('./core/modules/invite-admin/invite-admin.module').then((m) => m.InviteAdminModule),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./core/modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'profile',
        loadChildren: () => import('./core/modules/profile/profile.module').then((m) => m.ProfileModule),
      },
      {
        path: 'setting',
        loadChildren: () => import('./core/modules/setting/setting.module').then((m) => m.SettingModule),
      },
      {
        path: 'client',
        loadChildren: () => import('./core/modules/client/client.module').then((m) => m.ClientModule),
      },
      {
        path: 'loan',
        loadChildren: () => import('./core/modules/business-loan/business-loan.module').then((m) => m.BusinessLoanModule)
      },
      {
        path: '',
        loadChildren: () => import('./core/modules/management/management.module').then((m) => m.ManagementModule)
      }
    ],
  },
  { path: 'pagenotfound', loadChildren: () => import('./core/modules/error/error.module').then(m => m.ErrorModule) },
  { path: '', redirectTo: REDIRECT_DEFAULT, pathMatch: 'full' }, // Default route
  { path: '**', redirectTo: '/pagenotfound' }, // Wildcard route for 404
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
